import organisations from './organisations/model'
import profile from './profile/model'

export default {
    organisations,
    profile
}
